// Base units
export const ONE_SECOND_IN_MS = 1000
export const ONE_HOUR_IN_MINUTES = 60

// Seconds in milliseconds
export const HALF_A_SECOND = ONE_SECOND_IN_MS * 0.5
export const THREE_QUARTERS_OF_A_SECOND = ONE_SECOND_IN_MS * 0.75
export const THREE_AND_A_HALF_SECONDS_IN_MS = ONE_SECOND_IN_MS * 3.5
export const FIVE_SECONDS_IN_MS = ONE_SECOND_IN_MS * 5
export const TEN_SECONDS_IN_MS = ONE_SECOND_IN_MS * 10
export const FIFTEEN_SECONDS_IN_MS = ONE_SECOND_IN_MS * 15
export const THIRTY_SECONDS_IN_MS = ONE_SECOND_IN_MS * 30
export const NINETY_SECONDS_IN_MS = ONE_SECOND_IN_MS * 90

// Minutes in milliseconds
export const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * 60
export const FIVE_MINUTE_IN_MS = ONE_MINUTE_IN_MS * 5
export const FIFTEEN_MINUTES_IN_MS = ONE_MINUTE_IN_MS * 15

// Hours in seconds
export const ONE_HOUR_IN_SECONDS = ONE_HOUR_IN_MINUTES * 60

// Days in various units
export const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS * 24
export const TWO_DAYS_IN_SECONDS = ONE_DAY_IN_SECONDS * 2
export const ONE_DAY_IN_MINUTES = ONE_HOUR_IN_MINUTES * 24

// Weeks in seconds
export const ONE_WEEK_IN_SECONDS = ONE_DAY_IN_SECONDS * 7
export const TWO_WEEKS_IN_SECONDS = ONE_DAY_IN_SECONDS * 14

// Months in seconds (approximate)
export const THIRTY_DAYS_IN_SECONDS = ONE_DAY_IN_SECONDS * 30
export const SIXTY_DAYS_IN_SECONDS = ONE_DAY_IN_SECONDS * 60
export const ONE_HUNDRED_EIGHTY_DAYS_IN_SECONDS = ONE_DAY_IN_SECONDS * 180

// Years in seconds
export const ONE_YEAR_IN_SECONDS = ONE_DAY_IN_SECONDS * 365
export const SIXTEEN_YEARS_IN_SECONDS = ONE_YEAR_IN_SECONDS * 16

// Months in days
export const ONE_MONTH_IN_DAYS = 30
export const THREE_MONTHS_IN_DAYS = 91
export const SIX_MONTHS_IN_DAYS = 183
export const NINE_MONTHS_IN_DAYS = 274
export const ONE_YEAR_IN_DAYS = 365
export const FIFTEEN_MONTHS_IN_DAYS = 456
export const EIGHTEEN_MONTHS_IN_DAYS = 548
export const TWENTY_ONE_MONTHS_IN_DAYS = 639
export const TWO_YEARS_IN_DAYS = 730

export const MONTHS_AS_DAYS = {
  1: ONE_MONTH_IN_DAYS,
  3: THREE_MONTHS_IN_DAYS,
  6: SIX_MONTHS_IN_DAYS,
  9: NINE_MONTHS_IN_DAYS,
  12: ONE_YEAR_IN_DAYS,
  15: FIFTEEN_MONTHS_IN_DAYS,
  18: EIGHTEEN_MONTHS_IN_DAYS,
  21: TWENTY_ONE_MONTHS_IN_DAYS,
  24: TWO_YEARS_IN_DAYS,
} as const
Object.freeze(MONTHS_AS_DAYS)
export type MONTHS_AS_DAYS = (typeof MONTHS_AS_DAYS)[keyof typeof MONTHS_AS_DAYS]

export const DAYS_AS_MONTHS = {
  [ONE_MONTH_IN_DAYS]: 1,
  [THREE_MONTHS_IN_DAYS]: 3,
  [SIX_MONTHS_IN_DAYS]: 6,
  [NINE_MONTHS_IN_DAYS]: 9,
  [ONE_YEAR_IN_DAYS]: 12,
  [FIFTEEN_MONTHS_IN_DAYS]: 15,
  [EIGHTEEN_MONTHS_IN_DAYS]: 18,
  [TWENTY_ONE_MONTHS_IN_DAYS]: 21,
  [TWO_YEARS_IN_DAYS]: 24,
} as const
Object.freeze(DAYS_AS_MONTHS)
export type DAYS_AS_MONTHS = (typeof DAYS_AS_MONTHS)[keyof typeof DAYS_AS_MONTHS]
